import type { ITheme } from '@xterm/xterm';

const CSS_VAR_REGEX = /^var\((--[^)]+)\)$/;

export function getTerminalTheme(overrides?: ITheme): ITheme {
  const style = getComputedStyle(document.documentElement);

  const theme = {
    cursor: 'var(--bolt-elements-terminal-cursorColor)',
    cursorAccent: 'var(--bolt-elements-terminal-cursorColorAccent)',
    foreground: 'var(--bolt-elements-terminal-textColor)',
    background: 'var(--bolt-elements-terminal-backgroundColor)',
    selectionBackground: 'var(--bolt-elements-terminal-selection-backgroundColor)',
    selectionForeground: 'var(--bolt-elements-terminal-selection-textColor)',
    selectionInactiveBackground: 'var(--bolt-elements-terminal-selection-backgroundColorInactive)',

    // ansi escape code colors
    black: 'var(--bolt-elements-terminal-color-black)',
    red: 'var(--bolt-elements-terminal-color-red)',
    green: 'var(--bolt-elements-terminal-color-green)',
    yellow: 'var(--bolt-elements-terminal-color-yellow)',
    blue: 'var(--bolt-elements-terminal-color-blue)',
    magenta: 'var(--bolt-elements-terminal-color-magenta)',
    cyan: 'var(--bolt-elements-terminal-color-cyan)',
    white: 'var(--bolt-elements-terminal-color-white)',
    brightBlack: 'var(--bolt-elements-terminal-color-brightBlack)',
    brightRed: 'var(--bolt-elements-terminal-color-brightRed)',
    brightGreen: 'var(--bolt-elements-terminal-color-brightGreen)',
    brightYellow: 'var(--bolt-elements-terminal-color-brightYellow)',
    brightBlue: 'var(--bolt-elements-terminal-color-brightBlue)',
    brightMagenta: 'var(--bolt-elements-terminal-color-brightMagenta)',
    brightCyan: 'var(--bolt-elements-terminal-color-brightCyan)',
    brightWhite: 'var(--bolt-elements-terminal-color-brightWhite)',

    ...overrides,
  };

  return Object.fromEntries(
    Object.entries(theme).flatMap(([key, value]) => {
      if (typeof value === 'string') {
        const [, varName] = value.match(CSS_VAR_REGEX) ?? [];

        if (varName) {
          const computedValue = varName && style.getPropertyValue(varName);

          if (!computedValue) {
            return [];
          }

          value = computedValue;
        }
      }

      return [[key, value]];
    }),
  );
}
